"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logging_1 = require("@prosay/logging");
const logger = logging_1.getLogger(__filename);
exports.getPlatformUndefinedSymbol = Symbol("getPlatformUndefinedSymbol");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.getPlatform = (window = global["window"]) => {
    logger.debug `Window input is ${!!window}`;
    if (window === undefined || window === exports.getPlatformUndefinedSymbol) {
        return "node";
    }
    if (typeof window.document !== "undefined") {
        return "web";
    }
    else if (typeof window.navigator !== "undefined" &&
        window.navigator.product === "ReactNative") {
        return "react-native";
    }
    return "node";
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxhdGZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbC9wbGF0Zm9ybS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZDQUF5QztBQUV6QyxNQUFNLE1BQU0sR0FBRyxtQkFBUyxDQUFDLFVBQVUsQ0FBQyxDQUFBO0FBRXZCLFFBQUEsMEJBQTBCLEdBQUcsTUFBTSxDQUFDLDRCQUE0QixDQUFDLENBQUE7QUFFOUUsOERBQThEO0FBQ2pELFFBQUEsV0FBVyxHQUFHLENBQUMsU0FBZSxNQUFjLENBQUMsUUFBUSxDQUFDLEVBQUUsRUFBRTtJQUNuRSxNQUFNLENBQUMsS0FBSyxDQUFBLG1CQUFtQixDQUFDLENBQUMsTUFBTSxFQUFFLENBQUE7SUFDekMsSUFBSSxNQUFNLEtBQUssU0FBUyxJQUFJLE1BQU0sS0FBSyxrQ0FBMEIsRUFBRTtRQUMvRCxPQUFPLE1BQU0sQ0FBQTtLQUNoQjtJQUVELElBQUksT0FBTyxNQUFNLENBQUMsUUFBUSxLQUFLLFdBQVcsRUFBRTtRQUN4QyxPQUFPLEtBQUssQ0FBQTtLQUNmO1NBQU0sSUFDSCxPQUFPLE1BQU0sQ0FBQyxTQUFTLEtBQUssV0FBVztRQUN2QyxNQUFNLENBQUMsU0FBUyxDQUFDLE9BQU8sS0FBSyxhQUFhLEVBQzVDO1FBQ0UsT0FBTyxjQUFjLENBQUE7S0FDeEI7SUFDRCxPQUFPLE1BQU0sQ0FBQTtBQUNqQixDQUFDLENBQUEifQ==